<template>
<!-- Item -->
<div class="card shadow-sm">

    
<img  :src="pic" class="img-fluid img-thumbnail" style="width:100%;" /><b class="text-primary">{{item_name}}</b>

<div class="card-body">
    <p class="card-text">Item Code: {{item_code}}</p>
    <p class="card-text text-start">{{unit}} | {{weight}} | 富渔国际加拿大独家经销 | 贮存条件：存放于2~5摄氏度之间的阴凉干燥处</p>
    <p class="card-text text-start">产地： {{origin}}</p>
    <div class="d-flex justify-content-between align-items-center">
    <div class="btn-group">
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="addFavorate()"><van-icon name="like-o" class="c-red" /> 收藏</button>
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="shareLink()"><van-icon name="share" /> 分享</button>
    </div>
    <!--<span class="c-red">${{price}} ({{unit}})</span>-->
    </div>
</div>
</div>
</template>
<script>
  import { Toast } from 'vant'
  import { onMounted, onBeforeMount } from 'vue'
  export default {
    name: 'Item',
    props: {
        item_code: {
            type: String,
            default: ''
        },
        item_name: {
            type: String,
            default: ''
        },
        unit: {
            type: String,
            default: ''
        },
        price: {
            type: Number,
            default: 0.00
        },
        weight: {
            type: String,
            default: '1 oz'
        },
        pic: {
            type: String,
            default: ''
        },
        origin: {
            type: String,
            default: '马来西亚'
        }
    },
    setup() {
        const addFavorate = () => {
            Toast('已加入收藏夹')
        }
        const shareLink = () => {
            const input = document.createElement("input")
            input.value = window.location.href
            document.body.appendChild(input)
            input.select()
            document.execCommand("Copy")
            document.body.removeChild(input)
            Toast('链接已拷贝到剪切板')
        }
        onMounted(() => {
            console.log("Item mounted!")
        })
        onBeforeMount(() => {
            console.log("before mount executed!" )
        })

        return {addFavorate, shareLink}
    }
  };
</script>
<style lang="scss" scoped>
</style>